export default {
  form: {
    address: {
      delivery: {
        placeholder: 'Zoek je bezorgadres',
      },
      placeholder: 'Voer adres in om dichtstbijzijnde locatie te vinden',
    },
  },
  toasts: {
    failed_to_load_stores: 'Laden van winkels mislukt, vernieuw de pagina',
  },
  errors: {
    no_delivery_companies: 'Bezorging niet beschikbaar voor dit adres',
    delivery_not_available: 'Helaas bieden we momenteel geen bezorging aan',
    location_unavailable: 'Locatie niet toegankelijk, schakel toestemming in of voer het adres handmatig in',
    location_lookup_failed: 'Adres kon niet worden opgezocht, probeer het opnieuw',
    address_suggestions_unavailable: 'Adressuggesties konden niet worden geladen.',
  },
  buttons: {
    use_current_location: 'Gebruik mijn huidige locatie',
    locating: 'Locatie zoeken…',
    retry: 'Probeer het opnieuw',
  },
};
